import {Link, useParams} from "react-router-dom";
import {ReactComponent as PlusIcon} from "../assets/fonts/feather/plus-circle.svg";
import {useEffect, useState} from "react";
import Loader from "./Loader";
import {Skeleton} from "primereact/skeleton";
import {ScrollPanel} from "primereact/scrollpanel";


function NavFilter(params) {

    const [items, setItems] = useState([])

    // let p = useParams()
    let current = false
    let allCounter = 0;

    params.options.map(function (el, i) {
        allCounter += el.count;
    })

    useEffect(() => {
        setItems(params.options)
    }, [params]);


    return (
        items.length > 0 ?

                <ul className="nav nav-tabs border-tab align-items-center ">


                    {!params.hideAll &&
                        <li className="nav-item">
                            <a href="#" className={"nav-link " + (!params.active ? 'active' : '')}
                               onClick={() => params.handleClick()}>Все


                                <span
                                    className={"badge m-l-10 rounded-pill " + (!params.active ? ' badge-primary' : ' badge-light-primary')}>{allCounter}</span>

                            </a>
                        </li>
                    }

                    {items.map(function (el, i) {

                        return (
                            <li key={'nav-el-' + i} className="nav-item">
                                <a href="#" className={"nav-link " + (params.active === el.query ? 'active' : '')}
                                   onClick={(e) => { e.preventDefault(); params.handleClick(el.query)}}>{el.label}
                                    <span
                                        className={"badge  m-l-10 rounded-pill" + (params.active === el.query ? ' badge-primary' : ' badge-light-primary') + ''}>{el.count}</span>
                                </a>


                            </li>
                        )
                    })}

                </ul>
         :
            <div className={'d-flex gap-3'}><Skeleton width="100px" height="36px"/><Skeleton width="100px"
                                                                                             height="36px"/><Skeleton
                width="100px" height="36px"/><Skeleton width="100px" height="36px"/><Skeleton width="100px"
                                                                                              height="36px"/></div>
    )
}

export default NavFilter